<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-4">
        <page-header
          title="View Size"
          :return_button="true"
          return_link="/staff/sizes"
          :action_button="false"
          action_button_text=""
          action_button_link=""
        ></page-header>
        <div class="row mt-3">
          <div class="col-md-12">
            <div v-if="success" class="alert alert-success" role="alert">
              {{ success }}
            </div>
            <div
              v-if="errors.length > 0"
              class="alert alert-danger"
              role="alert"
            >
              <ul>
                <li v-for="error in errors" :key="error">{{ error }}</li>
              </ul>
            </div>
            <div class="form-group">
              <label for="name" class="form-label">Code</label>
              <input
                type="text"
                class="form-control"
                id="code"
                placeholder="Enter size code. E.g UK12"
                v-model="form.code"
                :disabled="true"
              />
            </div>
            <div class="form-group">
              <label for="email" class="form-label">Name</label>
              <input
                type="text"
                class="form-control"
                id="name"
                placeholder="Enter size name. E.g UK 12"
                v-model="form.name"
                :disabled="loading.form"
              />
            </div>
            <div class="text-end">
              <button
                @click.prevent="onSubmit"
                type="button"
                class="btn btn-outline-primary mt-3 w-100"
                :disabled="loading.form"
              >
                {{ loading.form ? "Loading, please wait..." : "Update Size" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/layout/navigation/PageHeader.vue";
import SizeService from "@/services/staff/SizeService";
import { formatErrors } from "@/utils/helpers";

export default {
  name: "ViewSizeView",
  components: {
    PageHeader,
  },
  data() {
    return {
      loading: {
        form: false,
      },
      form: {
        code: "",
        name: "",
      },
      success: "",
      errors: [],
    };
  },
  mounted() {
    SizeService.getSize(this.$route.params.id).then((response) => {
      const size = response.data.size;
      this.form.code = size.code;
      this.form.name = size.name;
    });
  },
  methods: {
    onSubmit() {
      this.loading.form = true;

      // Clear success and error message.
      this.success = "";
      this.errors = [];

      SizeService.updateSize(this.$route.params.id, this.form)
        .then((response) => {
          this.success = response.data.message;
        })
        .catch((error) => {
          let scope = this;
          scope.errors = formatErrors(error);
        })
        .finally(() => {
          this.loading.form = false;
        });
    },
  },
};
</script>
